/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_H1Inputs */

const en_minifier_h1 = /** @type {(inputs: Minifier_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Minifier`)
};

const ko_minifier_h1 = /** @type {(inputs: Minifier_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 압축기`)
};

const ja_minifier_h1 = /** @type {(inputs: Minifier_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON圧縮ツール`)
};

/**
* | output |
* | --- |
* | "JSON Minifier" |
*
* @param {Minifier_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_h1 = /** @type {((inputs?: Minifier_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_h1(inputs)
	if (locale === "ko") return ko_minifier_h1(inputs)
	return ja_minifier_h1(inputs)
});